import { api } from '@/api/index';
import { IUnknownObject } from "@/@types/common";

interface ISignUp {
    phone: string,
    password: string,
    ownershipType: number,
    bin: string,
    name: string,
    stat: object
}

interface IEntranceCreate extends IUnknownObject{
    name: string,
    cityId: number,
    capacity: number,
    address: string,
    login: string,
    password: string,
    firstName: string,
    lastName: string,
    middleName: string | null,
    iin: string,
    phone: string
}

interface ITurnstileCreate extends IUnknownObject{
    name: string,
    sn: string,
    entranceId: number,
    reverseDirection: boolean
}

interface UploadResponse {
    message?: string;
    data: any; 
  }

export default {
    v1: {
        auth: {
            login: async (login: string, password: string) => await api.post('/api/v1/auth/login', { login, password }),
            me: async () => await api.get('/api/v1/auth/me'),

            signUp: async (data: ISignUp) => await api.post('/api/v1/auth/signup', data),
            sendSms: async (phone: string) => await api.post('/api/v1/auth/send_sms', { phone }),
            verifySms: async (phone: string, code: string) => await api.post('/api/v1/auth/verify_sms', { phone, code }),
            changePassword: async (phone: string, code: string, password: string) => await api.post('/api/v1/auth/change_password', { phone, code, password }),
        },
        humans: {
            index: async (params: IUnknownObject) => await api.get('/api/v1/humans?' + new URLSearchParams(params).toString()),
            create: async (params: IUnknownObject) => await api.post('/api/v1/humans', params, { headers: { "Content-Type": "multipart/form-data" } }),
            linkCard: async (id: number, params: IUnknownObject) => await api.post('/api/v1/humans/' + id + '/link_card', params),
            update: async (id: number, params: IUnknownObject) => await api.patch('/api/v1/humans/' + id, params, { headers: { "Content-Type": "multipart/form-data" } }),
            hikvisionPersonAdd: async (id: number, faceStudent: string) =>
                await api.post(`/api/v1/humans/${id}/hikvision/person`, { face_student: faceStudent }),
            hikvisionPersonUpdate: async (id: number, faceStudent: string) =>
                await api.post(`/api/v1/humans/${id}/hikvision/person/update`, { face_student: faceStudent }),
            hikvisionUserSync: async (id: number, faceStudent: string) =>
                await api.post(`/api/v1/humans/${id}/hikvision/user`, { face_student: faceStudent }),
            hikvisionUserRemove: async (id: number) =>
                await api.delete(`/api/v1/humans/${id}/hikvision/user`),
            dahuaSync: async (id: number, faceStudent: string) =>
                await api.post(`/api/v1/humans/${id}/dahua`, { face_student: faceStudent }),
            lostCard: async (id: number) => await api.post('/api/v1/humans/' + id + '/lost_card'),
            setActive: async (id: number, state: boolean) => await api.post('/api/v1/humans/' + id + '/set_active', {
                active: state,
            }),
            remove: async (id: number, reason: string) => await api.delete('/api/v1/humans/' + id, { data: { reason } }),
            checkCard: async (code: string) => await api.post('/api/v1/humans/check_card', {
                code: code,
            }),
            updateStepOne: async (id: number, params: IUnknownObject) => await api.patch('/api/v1/humans/' + id + '/step_one', params),
            updateStepTwo: async (id: number, params: IUnknownObject) => await api.patch('/api/v1/humans/' + id + '/step_two', params, { headers: { 'Content-type': 'multipart/form-date', }}),
            updateStepThree: async (id: number, params: IUnknownObject) => await api.patch('/api/v1/humans/' + id + '/step_three', params, { headers: { 'Content-type': 'multipart/form-date', }}),
            checkIin: async (iin: string, id = 0) => await api.post('/api/v1/humans/check_iin', { iin: iin, id: id }),
            getDeleted: async (params: IUnknownObject) => await api.get('/api/v1/humans/deleted?' + new URLSearchParams(params).toString()),
            uploadExcelAsBase64: async (base64Data: string, fileName: string): Promise<any> => {
                // Отправляем JSON: { base64, filename }
                return api.post('/api/v1/humans/upload_base64', {
                  base64: base64Data,
                  filename: fileName,
                })
                .then(r => r.data)
                .catch(error => {
                  throw error.response?.data || { message: 'Произошла ошибка' };
                });
              },
              uploadExcelRows: async (validRows: IUnknownObject): Promise<any> =>{
                return await api.post('/api/v1/humans/uploadExcelRows', { validRows })
                .then(r => r.data)
                .catch(error => {
                  throw error.response?.data || { message: 'Произошла ошибка' };
                });
              },
              checkExistingIins: async (iins: IUnknownObject): Promise<any> => {
                return await api.post('/api/v1/humans/checkExistingIins', { iins })
                  .then(r => r.data)
                  .catch(error => {
                    throw error.response?.data || { message: 'Произошла ошибка' };
                  });
              },
              // Обновление статуса импорта студентов
              updateImportStatus: async (studentsImported: boolean): Promise<any> => {
                return await api.post('/api/v1/humans/import-status', { studentsImported })
                  .then(r => r.data)
                  .catch(error => {
                    throw error.response?.data || { message: 'Произошла ошибка' };
                  });
              },
              // Получение статуса импорта студентов
              getImportStatus: async (): Promise<any> => {
                return await api.get('/api/v1/humans/import-status')
                  .then(r => r.data)
                  .catch(error => {
                    throw error.response?.data || { message: 'Произошла ошибка' };
                  });
              },

              
        },
        activityLogs: {
            index: async (params: IUnknownObject) => await api
                .get('/api/v1/activity-logs?' + new URLSearchParams(params).toString())
                .then((r) => r.data),
            show: async (id: number) => await api
                .get('/api/v1/activity-logs/' + id)
                .then((r) => r.data),
        },
        auditLogs: {
            index: async (params: IUnknownObject) => await api
                .get('/api/v1/audit-logs?' + new URLSearchParams(params).toString())
                .then((r) => r.data),
            show: async (id: number) => await api
                .get('/api/v1/audit-logs/' + id)
                .then((r) => r.data),
            entityTypes: async () => await api
                .get('/api/v1/audit-logs/entity-types')
                .then((r) => r.data),
        },
        trash: {
            types: async () => await api.get('/api/v1/trash/types').then((r) => r.data),
            index: async (type: string, params: IUnknownObject) => await api
                .get(`/api/v1/trash/${type}?` + new URLSearchParams(params).toString())
                .then((r) => r.data),
            restore: async (type: string, id: number, reason: string) => await api
                .post(`/api/v1/trash/${type}/${id}/restore`, { reason })
                .then((r) => r.data),
        },
        users: {
            index: async (params: IUnknownObject) => await api.get('/api/v1/users?' + new URLSearchParams(params).toString()),
            create: async (data: { login: string, password: string, firstName?: string, lastName?: string, middleName?: string, iin?: string, phone?: string, position?: string, roleAlias: string }) => await api.post('/api/v1/users', data),
            update: async (id: number, data: { login?: string, password?: string, firstName?: string, lastName?: string, middleName?: string, iin?: string, phone?: string }) => await api.patch(`/api/v1/users/${id}`, data),
            resetPassword: async (id: number) => await api.post('/api/v1/password_recovery/generate', { userId: id }),
            changePassword: async (password: string, token: string) => await api.post('/api/v1/password_recovery/reset_password/', { newPassword: password, token: token }),
            validateToken: async (params: IUnknownObject) => await api.get('/api/v1/password_recovery/validate_token?' + new URLSearchParams(params).toString()),
        },
        entrances: {
            index: async () => await api.get('/api/v1/entrances'),
            faceIdFlag: async () => await api.get('/api/v1/entrances/face-id-flag'),
            faceIdDevices: async () => await api.get('/api/v1/entrances/face-id/devices'),
            create: async (data: IEntranceCreate) => await api.post('/api/v1/entrances', data),
            update: async (id: number, data: IUnknownObject) => await api.patch('/api/v1/entrances/' + id, data),
            checkLogin: async (data: IUnknownObject) => await api.post('/api/v1/entrances/check_login', data),
            remove: async (id: number, reason: string) => await api.delete('/api/v1/entrances/' + id, { data: { reason } }),
        },
        turnstiles: {
            index: async () => await api.get('/api/v1/turnstiles'),
            create: async (data: ITurnstileCreate) => await api.post('/api/v1/turnstiles', data),
            update: async (id: number, data: IUnknownObject) => await api.patch('/api/v1/turnstiles/' + id, data),
            remove: async (id: number, reason: string) => await api.delete('/api/v1/turnstiles/' + id, { data: { reason } }),
        },
        apiClients: {
            index: async () => await api.get('/api/v1/api-clients'),
            create: async (data: IUnknownObject) => await api.post('/api/v1/api-clients', data),
            createKey: async (id: number, data: IUnknownObject = {}) => await api.post('/api/v1/api-clients/' + id + '/keys', data),
            revokeKey: async (id: number, keyId: number) => await api.delete('/api/v1/api-clients/' + id + '/keys/' + keyId),
            setActive: async (id: number, isActive: boolean) => await api.patch('/api/v1/api-clients/' + id + '/active', { isActive }),
        },
        info: {
            cities: {
                get: async () => await api.get('/api/v1/info/cities'),
            },
            entrances: {
                get: async () => await api.get('/api/v1/info/entrances'),
            },
            universities: {
                get: async () => await api.get('/api/v1/info/universities'),
            },
            institutions: {
                get: async () => await api.get('/api/v1/info/institutions'),
                getAll: async () => await api.get('/api/v1/info/institutions_all'),
            },
            educations: {
                get: async () => await api.get('/api/v1/info/educations'),
            },
            humanRoles: {
                get: async () => await api.get('/api/v1/info/human_roles'),
            },
            roles: {
                get: async () => await api.get('/api/v1/info/roles'),
            },
        },
        reports: {
            get: async (params: IUnknownObject) => await api.post('/api/v1/reports', params),
            excel: async (params: IUnknownObject) => await api.post('/api/v1/reports/excel', params, { responseType: 'arraybuffer' }),
            exports: async () => await api.get('/api/v1/reports/exports'),
            createExport: async (data: { dateStart: string; dateEnd: string; type?: string; entrance_id?: number | null }) =>
                await api.post('/api/v1/reports/exports', data),
            deleteExport: async (id: number) => await api.delete(`/api/v1/reports/exports/${id}`),
        },
        registries: {
             /**
             * Получение данных для формирования реестра
             */
            get: async (params: IUnknownObject) =>
                await api.post('/api/v1/registries', params),

             /**
             * Получение данных для формирования реестра
             */
            getRegistries: async () =>
                await api.post('/api/v1/registries/getRegistries'),


            getExists: async (params: IUnknownObject) =>
                await api.post('/api/v1/registries/getExists', params),

            /**
             * Получить реестр по пользователю (пример, если требуется)
             */
            getUserReestr: async (params: { userId: number }) =>
                await api.post('/api/v1/registries/getUserReestr', params),

            decode_qr: async (params: { code: string }) =>
                await api.post('/api/v1/registries/decode_qr', params),

            updateSubmitForApprovalBase64: async (payload: {
                removedIds: any;
                removedIdsAudit: any;
                dormitory: number | string;
                month: string;
                year: number | string;
                totalSumCollegeAudit: number | string;
                totalSumUniversityAudit: number | string;
                updateUserId: number | string;
                status: string;
            }): Promise<any> => {
                return api
                    .post('/api/v1/registries/updateSubmitForApprovalBase64', payload)
                    .then((r) => r.data)
                    .catch((error) => {
                        throw error.response?.data || { message: 'Произошла ошибка' };
                    });
            },

            /**
             * Выгрузка всех реестров в Excel для audit
             */
            exportAllRegistriesExcel: async (): Promise<any> => {
                return await api.get('/api/v1/registries/export-all-excel', {
                    responseType: 'blob', // Важно для скачивания файла
                })
                .then((response) => {
                    // Создаем ссылку для скачивания
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const contentDisposition = response.headers['content-disposition'];
                    let filename = 'all_registries.xlsx';
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                        if (filenameMatch) {
                            filename = filenameMatch[1];
                        }
                    }
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    return { success: true, message: 'Файл успешно скачан' };
                })
                .catch((error) => {
                    throw error.response?.data || { message: 'Произошла ошибка при выгрузке' };
                });
            },
            /**
             * Отправка данных реестра на согласование
             * (при необходимости оставляем, если логика нужна)
             */
            submitForApprovalBase64: async (payload: {
                removedIds: any;
                dormitory: number | string;
                month: string;
                year: number | string;
                // totalSumCollege: number | string;
                // totalSumUniversity: number | string;
                createUserId: number | string;
            }): Promise<any> => {
                return api
                    .post('/api/v1/registries/submitForApprovalBase64', payload)
                    .then((r) => r.data)
                    .catch((error) => {
                        throw error.response?.data || { message: 'Произошла ошибка' };
                    });
            },

            /**
             * Проверка существования реестра
             */
            checkExist: async (params: { dormitory: number; month: string; year: number }) => {
                return api.post('/api/v1/registries/checkExist', { params })
                  .then(r => r.data)
                  .catch(e => {
                    console.log(e);
                    throw e.response?.data || 'Error checkExist';
                  });
            },
            

            /**
             * Обновление статуса реестра
             */
            updateStatus: async (payload: { id: number; status: string; reason?: string }) => {
                return api
                    .post('/api/v1/registries/updateStatus', payload)
                    .then((r) => r.data);
            },

            /**
             * Проверка сертификата перед подписанием
             */
            checkCertificate: async (payloadData: { p12: string; password: string; userIin: string }) => {
                return api
                    .post('/api/v1/registries/check-certificate', payloadData)
                    .then((r) => r.data);
            },

            /**
             * Подпись ЭЦП (если используется в проекте)
             */
            signECP: async (payloadData: { registriesId: number; p12: string; password: string; userIin: string }) => {
                return api
                    .post('/api/v1/registries/signECP', payloadData)
                    .then((r) => r.data);
            },

            /**
             * Скачивание подписанного документа
             */
            downloadSigned: async (id: number) => {
                return api
                    .get(`/api/v1/registries/${id}/download-signed`, {
                        responseType: 'blob'
                    })
                    .then((response) => {
                        // Создаем URL для скачивания
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        // Получаем имя файла из заголовков
                        const contentDisposition = response.headers['content-disposition'];
                        let fileName = `signed_document_${id}.cms`;
                        if (contentDisposition) {
                            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                            if (fileNameMatch) {
                                fileName = fileNameMatch[1];
                            }
                        }
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);
                        return response.data;
                    });
            },

            /**
             * Новая функция для скачивания реестра:
             * - бэкенд может вернуть бинарные данные (zip/pdf/xlsx и т.д.)
             * - или объект с fileUrl (ссылкой)
             */
            download: async (params: IUnknownObject) => {
                return api
                    .post('/api/v1/registries/download', params)
                    .then((r) => r.data)
                    .catch((e) => {
                        throw e.response?.data || 'Error download';
                    });
            },
            downloadStatus: async (jobId: string) => {
                return api
                    .get('/api/v1/registries/download/status/' + encodeURIComponent(String(jobId)))
                    .then((r) => r.data)
                    .catch((e) => {
                        throw e.response?.data || 'Error download status';
                    });
            },

            /**
             * Получить удаленных студентов для реестра
             */
            getRemovedStudents: async (registryId: number, type?: 'manual' | 'audit') => {
                const params = new URLSearchParams({ registryId: String(registryId) });
                if (type) params.append('type', type);
                
                return api
                    .get('/api/v1/registries/removed-students?' + params.toString())
                    .then((r) => r.data)
                    .catch((e) => {
                        throw e.response?.data || 'Error getting removed students';
                    });
            },

            /**
             * Добавить студента в список удаленных
             */
            addRemovedStudent: async (payload: { 
                registryId: number; 
                humanId: number; 
                reason?: string; 
                type?: 'manual' | 'audit' 
            }) => {
                return api
                    .post('/api/v1/registries/removed-students', payload)
                    .then((r) => r.data)
                    .catch((e) => {
                        throw e.response?.data || 'Error adding removed student';
                    });
            },

            /**
             * Обновить причину удаления студента
             */
            updateRemovalReason: async (removedStudentId: number, reason: string) => {
                return api
                    .put(`/api/v1/registries/removed-students/${removedStudentId}/reason`, { reason })
                    .then((r) => r.data)
                    .catch((e) => {
                        throw e.response?.data || 'Error updating removal reason';
                    });
            },

            /**
             * Восстановить студента (убрать из удаленных)
             */
            restoreStudent: async (removedStudentId: number, reason: string) => {
                return api
                    .delete(`/api/v1/registries/removed-students/${removedStudentId}`, { data: { reason } })
                    .then((r) => r.data)
                    .catch((e) => {
                        throw e.response?.data || 'Error restoring student';
                    });
            },

            /**
             * Получить статистику удаленных студентов
             */
            getRemovalStats: async (registryId: number) => {
                return api
                    .get('/api/v1/registries/removed-students/stats?registryId=' + registryId)
                    .then((r) => r.data)
                    .catch((e) => {
                        throw e.response?.data || 'Error getting removal stats';
                    });
            },

            /**
             * Миграция данных из старого JSON формата в новую таблицу
             */
            migrateRemovedStudentsData: async () => {
                return api
                    .post('/api/v1/registries/migrate-removed-students')
                    .then((r) => r.data)
                    .catch((e) => {
                        throw e.response?.data || 'Error migrating removed students data';
                    });
            },
              
        },
        moderation: {
            get: async () => await api.get('/api/v1/moderation'),
            approve: async (params: IUnknownObject) => await api.post('/api/v1/moderation/approve', params),
            reject: async (params: IUnknownObject) => await api.post('/api/v1/moderation/reject', params),
        },
        dashboard: {
            get: async () => await api.get('/api/v1/main/dashboard'),
        },
        activity: {
            get: async (params: IUnknownObject) => await api.post('/api/v1/main/activity', params),
        },
        ovpo: {
            get: async (roleId = 0) => await api.get('/api/v1/ovpo?id=' + roleId),
            create: async (params: IUnknownObject) => await api.post('/api/v1/ovpo', params),
        },
        ovpoReports: {
            get: async () => await api.get('/api/v1/ovpo_reports'),
            show: async (id: number) => await api.get('/api/v1/ovpo_reports/' + id),
            changeStudying: async (id: number, value: boolean) => await api.post('/api/v1/ovpo_reports/' + id + '/change_studying', { value: Number(value) }),
            changeLiving: async (id: number, value: boolean) => await api.post('/api/v1/ovpo_reports/' + id + '/change_living', { value: Number(value) }),
            changeComment: async (id: number, value: boolean) => await api.post('/api/v1/ovpo_reports/' + id + '/change_comment', { value: Number(value) }),
            moderation: async (id: number) => await api.post('/api/v1/ovpo_reports/' + id + '/moderation'),
            reject: async (id: number) => await api.post('/api/v1/ovpo_reports/' + id + '/reject'),
            download: async (id: number) => await api.post('/api/v1/ovpo_reports/' + id + '/download', {}, { responseType: 'arraybuffer' }),
            getXml: async (id: number) => await api.post('/api/v1/ovpo_reports/' + id + '/get_xml'),
            sign: async (id: number, params: any) => await api.post('/api/v1/ovpo_reports/' + id + '/sign', params),
        },
        institutions: {
            index: async (params: IUnknownObject) => await api.get('/api/v1/institutions?' + new URLSearchParams(params).toString()),
            create: async (params: IUnknownObject) => await api.post('/api/v1/institutions', params),
            update: async (id: number, params: IUnknownObject) => await api.patch('/api/v1/institutions/' + id, params),
            syncEvpoStatus: async (id: number) => await api.post('/api/v1/institutions/' + id + '/sync-evpo-status'),
            syncEvpoStatusAll: async () => await api.post(
                '/api/v1/institutions/sync-evpo-status-all',
                {},
                { timeout: 30000 },
            ),
            getEvpoBulkSyncCurrent: async () => await api.get(
                '/api/v1/institutions/sync-evpo-status-all/current',
                { timeout: 15000 },
            ),
            getEvpoStatusRequestLogs: async (params?: { page?: number; per_page?: number }) => await api.get(
                '/api/v1/institutions/epvo-status-request-logs',
                { params: params ?? { page: 1, per_page: 15 } },
            ),
            getEvpoBulkSyncStatus: async (runId: number) => await api.get(
                '/api/v1/institutions/sync-evpo-status-all/' + runId + '/status',
                { timeout: 15000 },
            ),
            remove: async (id: number, reason: string) => await api.delete('/api/v1/institutions/' + id, { data: { reason } }),
        },
        esf: {
            compare_esf: async (params: IUnknownObject) => await api.post('/api/v1/esf', params),
            export_one_c_result: async (params: IUnknownObject) => await api.post('/api/v1/export_one_c_result', params),
        },
        finance: {
            index: async (params: IUnknownObject) => await api.get('/api/v1/finance', params),
            create: async (params: IUnknownObject) => await api.post('/api/v1/finance', params),
            update: async (id: number, params: IUnknownObject) => await api.patch('/api/v1/finance/' + id, params),
            delete: async (id: number, reason: string) => await api.delete('/api/v1/finance/' + id, { data: { reason } }),
            exportStudentExcel: async (params: IUnknownObject) => {
                const response = await api.get('/api/v1/finance/export/student/excel?' + new URLSearchParams(params).toString(), { responseType: 'blob' });
                return response.data;
            },
            filePaths: async () => await api.get('/api/v1/finance/file_paths').then((r) => r.data),
            exportExcel: async (params: IUnknownObject) => {
                const response = await api.get('/api/v1/finance/export/excel?' + new URLSearchParams(params).toString(), { responseType: 'blob' });
                return response.data;
            },
        },
        acts: {
            index: async (params: IUnknownObject) => await api.get('/api/v1/acts?' + new URLSearchParams(params).toString()).then((r) => r.data),
            compare: async (params: IUnknownObject) => await api.post('/api/v1/acts/compare', params).then((r) => r.data),
            act: async (params: IUnknownObject) => await api.post('/api/v1/acts', params).then((r) => r.data),
            export: async (params: IUnknownObject) => {
                const response = await api.get('/api/v1/acts/export?' + new URLSearchParams(params).toString(), { responseType: 'blob' });
                return response.data;
            },
            exportActs: async (params: IUnknownObject) => {
                const response = await api.get('/api/v1/acts/export_acts?' + new URLSearchParams(params).toString(), { responseType: 'blob' });
                return response.data;
            },
            cities: async () => await api.get('/api/v1/acts/cities').then((r) => r.data),
            request_egz: async () => await api.get('/api/v1/acts/request-egz').then((r) => r.data),
            configure_bank: async (params: IUnknownObject) => await api.post('/api/v1/acts/configure-bank', params).then((r) => r.data),
            bank_details: async () => await api.get('/api/v1/acts/bank-details').then((r) => r.data),
            deleteBank: async (id: number) => await api.delete('/api/v1/acts/banks/' + id).then((r) => r.data),
            entrances: async () => await api.get('/api/v1/acts/entrances').then((r) => r.data),
            oneC: async (params: IUnknownObject) => {
                const response = await api.get('/api/v1/acts/one_c?' + new URLSearchParams(params).toString(), { responseType: 'blob' });
                return response.data;
            },
            getFileUrl: async (filePath: string) => {
                // Возвращаем полный URL для скачивания файла через API
                const response = await api.get('/api/v1/acts/file?' + new URLSearchParams({ path: filePath }).toString());
                return response.data;
            },
        },
        reconciliation: {
            // Получение списка актов сверок
            getList: async (params: IUnknownObject) => await api.get('/api/v1/reconciliation?' + new URLSearchParams(params).toString()).then((r) => r.data),
            // Удаление акта (и связанных файлов)
            delete: (id: number, reason: string) => api.delete(`/api/v1/reconciliation/${id}`, { data: { reason } }).then((r) => r.data),
            // Проверка сертификата (валидация пароля)
            checkCertificate: async (payloadData: { p12: string; password: string; userIin: string }) => {
                return api.post('/api/v1/reconciliation/check-certificate', payloadData).then((r) => r.data);
            },
            // Подписание акта общежитием
            signDorm: async (id: number) => await api.patch(`/api/v1/reconciliation/${id}/sign-dorm`).then((r) => r.data),
            // Подписание акта общежитием через ЭЦП
            signDormECP: async (payloadData: { id: number; p12: string; password: string; userIin: string }) => {
                return api.patch(`/api/v1/reconciliation/${payloadData.id}/sign-dorm-ecp`, {
                    p12: payloadData.p12,
                    password: payloadData.password,
                    userIin: payloadData.userIin,
                }).then((r) => r.data);
            },
            // Подписание акта финансовым директором
            signFinance: async (id: number) => await api.patch(`/api/v1/reconciliation/${id}/sign-finance`).then((r) => r.data),
            // Подписание акта финансовым директором через ЭЦП
            signFinanceECP: async (payloadData: { id: number; p12: string; password: string; userIin: string }) => {
                return api.patch(`/api/v1/reconciliation/${payloadData.id}/sign-finance-ecp`, {
                    p12: payloadData.p12,
                    password: payloadData.password,
                    userIin: payloadData.userIin,
                }).then((r) => r.data);
            },
            // Скачивание подписанного CMS файла
            downloadSignedCms: async (id: number) => {
                return api.get(`/api/v1/reconciliation/${id}/download-signed`, {
                    responseType: 'blob'
                }).then((response) => {
                    // Создаем URL для скачивания
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    // Получаем имя файла из заголовков
                    const contentDisposition = response.headers['content-disposition'];
                    let fileName = `signed_act_${id}.cms`;
                    if (contentDisposition) {
                        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                        if (fileNameMatch) {
                            fileName = fileNameMatch[1];
                        }
                    }
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    return response.data;
                });
            },
            // Скачивание финального PDF с QR-кодом
            downloadFinalPdf: async (id: number) => {
                return api.get(`/api/v1/reconciliation/${id}/download-final`, {
                    responseType: 'blob'
                }).then((response) => {
                    // Создаем URL для скачивания
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    // Получаем имя файла из заголовков
                    const contentDisposition = response.headers['content-disposition'];
                    let fileName = `final_act_${id}.pdf`;
                    if (contentDisposition) {
                        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                        if (fileNameMatch) {
                            fileName = fileNameMatch[1];
                        }
                    }
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    return response.data;
                });
            },
            // Экспорт актов в Excel
            export: async (params: IUnknownObject) => {
                return await api.get('/api/v1/reconciliation/export?' + new URLSearchParams(params).toString(), {
                    responseType: 'blob',
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const contentDisposition = response.headers['content-disposition'];
                    let filename = 'reconciliation-acts.xlsx';
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                        if (filenameMatch) {
                            filename = filenameMatch[1];
                        }
                    }
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    return { success: true, message: 'Файл успешно скачан' };
                })
                .catch((error) => {
                    throw error.response?.data || { message: 'Ошибка при выгрузке' };
                });
            },
        },
        pendingPassings: {
            getList: () => api.get('/api/v1/pending-passings').then((r) => r.data),
            resolve: (id: number) => api.post(`/api/v1/pending-passings/${id}/resolve`).then((r) => r.data),
        },
        notifications: {
            index: async () => await api.get('/api/v1/notifications'),
            markRead: async (key: string) => await api.post(`/api/v1/notifications/${encodeURIComponent(key)}/read`),
        },
    },
};
